import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column w-325px w-md-375px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "px-7 py-5" }
const _hoisted_3 = { class: "fs-5 text-dark fw-bolder" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_5 = { class: "px-7 py-5" }
const _hoisted_6 = { class: "row mb-8" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fs-6" }, "From", -1)
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fs-6" }, "To", -1)
const _hoisted_11 = { class: "row mb-8" }
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "fs-6" }, "Start Time", -1)
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "fs-6" }, "End Time", -1)
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "row mb-8" }
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = {
  key: 0,
  class: "col-6"
}
const _hoisted_21 = {
  key: 1,
  class: "col-6"
}
const _hoisted_22 = ["label"]
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "row mb-8" }
const _hoisted_25 = { class: "col-6" }
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = { class: "row mb-8" }
const _hoisted_28 = { class: "col-6" }
const _hoisted_29 = { class: "col-6" }
const _hoisted_30 = ["label"]
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "row mb-8" }
const _hoisted_33 = { class: "col-6" }
const _hoisted_34 = ["label"]
const _hoisted_35 = ["value"]
const _hoisted_36 = {
  key: 0,
  class: "col-6"
}
const _hoisted_37 = ["label"]
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_CustomerSearchField = _resolveComponent("CustomerSearchField")!
  const _component_SearchField = _resolveComponent("SearchField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.translate('Filter Options')), 1)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_DatePicker, {
            id: "filterStartDate",
            class: "form-control form-control-sm form-control-solid",
            placeholder: _ctx.translate('dd/mm/yyyy'),
            fieldId: "filterStartDate",
            ignoreModel: true,
            onChange: _ctx.onStartDateChange,
            defaultDate: _ctx.selectedItems.startDate
          }, null, 8, ["placeholder", "onChange", "defaultDate"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_DatePicker, {
            id: "endDate",
            class: "form-control form-control-sm form-control-solid",
            placeholder: _ctx.translate('dd/mm/yyyy'),
            fieldId: "endDate",
            ignoreModel: true,
            onChange: _ctx.onEndDateChange,
            defaultDate: _ctx.selectedItems.endDate
          }, null, 8, ["placeholder", "onChange", "defaultDate"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            id: "startTime",
            class: "form-control form-control-sm form-control-solid",
            placeholder: _ctx.translate('hh:mm'),
            type: "time",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems.startTime) = $event))
          }, null, 8, _hoisted_14), [
            [_vModelText, _ctx.selectedItems.startTime]
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _withDirectives(_createElementVNode("input", {
            id: "endTime",
            class: "form-control form-control-sm form-control-solid",
            placeholder: _ctx.translate('hh:mm'),
            type: "time",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItems.endTime) = $event))
          }, null, 8, _hoisted_17), [
            [_vModelText, _ctx.selectedItems.endTime]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_CustomerSearchField, {
            modelValue: _ctx.selectedItems.customerId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedItems.customerId) = $event)),
            options: _ctx.customers,
            mode: "single",
            label: _ctx.translate('Select customer'),
            className: "form-select-sm",
            "have-none": true
          }, null, 8, ["modelValue", "options", "label"])
        ]),
        (!_ctx.isTrainer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_SearchField, {
                modelValue: _ctx.selectedItems.trainerId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedItems.trainerId) = $event)),
                options: _ctx.trainers,
                mode: "single",
                label: _ctx.translate('Select Trainer'),
                className: "form-select-sm",
                "have-none": true
              }, null, 8, ["modelValue", "options", "label"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isTrainer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-sm form-select-solid",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedItems.typeId) = $event))
              }, [
                _createElementVNode("option", {
                  label: _ctx.translate('Class Type'),
                  selected: "",
                  disabled: "",
                  value: ""
                }, null, 8, _hoisted_22),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classType, (type) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: type.id,
                    value: type.id
                  }, _toDisplayString(type.nameEn), 9, _hoisted_23))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedItems.typeId]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_SearchField, {
            modelValue: _ctx.selectedItems.arenaId,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedItems.arenaId) = $event)),
            options: _ctx.arenas,
            mode: "single",
            label: _ctx.translate('Select Arena'),
            className: "form-select-sm",
            "have-none": true
          }, null, 8, ["modelValue", "options", "label"])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_SearchField, {
            modelValue: _ctx.selectedItems.horseId,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedItems.horseId) = $event)),
            options: _ctx.horses,
            mode: "single",
            label: _ctx.translate('Select Horse'),
            className: "form-select-sm",
            trackBy: "nameEn",
            "have-none": true
          }, null, 8, ["modelValue", "options", "label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_SearchField, {
            modelValue: _ctx.selectedItems.groomerId,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedItems.groomerId) = $event)),
            options: _ctx.groomers,
            mode: "single",
            label: _ctx.translate('Select Groomer'),
            className: "form-select-sm",
            "have-none": true
          }, null, 8, ["modelValue", "options", "label"])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select form-select-sm form-select-solid",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedItems.attendanceId) = $event))
          }, [
            _createElementVNode("option", {
              label: _ctx.translate('Select status'),
              selected: "",
              disabled: "",
              value: ""
            }, null, 8, _hoisted_30),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (status) => {
              return (_openBlock(), _createElementBlock("option", {
                key: status.id,
                value: status.id
              }, _toDisplayString(status.nameEn), 9, _hoisted_31))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.selectedItems.attendanceId]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select form-select-sm form-select-solid",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedItems.classCategoryId) = $event))
          }, [
            _createElementVNode("option", {
              label: _ctx.translate('Class Category'),
              selected: "",
              disabled: "",
              value: ""
            }, null, 8, _hoisted_34),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (category) => {
              return (_openBlock(), _createElementBlock("option", {
                key: category.id,
                value: category.id
              }, _toDisplayString(category.nameEn), 9, _hoisted_35))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.selectedItems.classCategoryId]
          ])
        ]),
        (!_ctx.isTrainer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-sm form-select-solid",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedItems.typeId) = $event))
              }, [
                _createElementVNode("option", {
                  label: _ctx.translate('Class Type'),
                  selected: "",
                  disabled: "",
                  value: ""
                }, null, 8, _hoisted_37),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classType, (type) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: type.id,
                    value: type.id
                  }, _toDisplayString(type.nameEn), 9, _hoisted_38))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedItems.typeId]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("button", {
          type: "reset",
          class: "btn btn-sm btn-white btn-active-light-primary me-2",
          "data-kt-menu-dismiss": "true",
          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
        }, " Reset "),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-sm btn-primary",
          "data-kt-menu-dismiss": "true",
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, " Apply ")
      ])
    ])
  ]))
}